import { MulticreatorPackagePlanId } from '../../../../commonv3/types/multicreator_packages';
import { MulticreatorPackagePlanIndexView } from '../../../types/multicreator_packages';
import { observer } from 'mobx-react';
import Slider from 'react-slick';
import React from 'react';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import './packagePlanSelector.module.scss';
import classNames from 'classnames';

const DesktopContainer = ({ children }) => {
  return <div styleName="desktop-container">{children}</div>;
};

const MobileContainer = ({ children }) => {
  const settings = {
    className: 'slider variable-width',
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    adaptiveHeight: true,
    variableWidth: true,
    touchThreshold: 1000,
    infinite: false,
  };
  return <Slider {...settings}>{children}</Slider>;
};

type CardProps = {
  packagePlan: MulticreatorPackagePlanIndexView;
  selected: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelect: () => any;
};

const PackagePlanCard = ({ packagePlan, selected, onSelect }: CardProps) => {
  return (
    <div
      onClick={onSelect}
      className="package-plan-card"
      data-package-plan-id={packagePlan.id}
      styleName={classNames('package-plan-card', { selected: selected })}
    >
      {packagePlan.name}
    </div>
  );
};

type Props = {
  packagePlans: MulticreatorPackagePlanIndexView[];
  selectedPackagePlanId: MulticreatorPackagePlanId | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelect: (packagePlanId: MulticreatorPackagePlanId) => any;
};

export const PackagePlanSelector = observer(({ packagePlans, selectedPackagePlanId, onSelect }: Props) => {
  const Container = useViewportState().isNonSp ? DesktopContainer : MobileContainer;
  return (
    <Container>
      {packagePlans.map((plan) => (
        <PackagePlanCard
          key={plan.id}
          packagePlan={plan}
          selected={plan.id === selectedPackagePlanId}
          onSelect={() => onSelect(plan.id)}
        />
      ))}
    </Container>
  );
});
